import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { transactionListingApi } from '@apis/seller-center/orders.js';
import { Toast } from '@common-web/index.js';
import { getErrorString } from '@utils/utils.js';

const initialState = {
  ordersData: [],
  statuses: [],
  dispositions: [],
  pagination: null,
  success: false,
  loading: false,
};

export const fetchTransactionsListing = createAsyncThunk('transactions/listing', async (params = '') => {
  try {
    const transactions = await transactionListingApi(params);
    return transactions;
  } catch (err) {
    Toast.error(getErrorString(err));
  }
  return {};
});

const TransactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    filterDispositions: (state, action) => {
      if (action.payload?.statusIndex !== -1) {
        state.dispositions = state.statuses?.[action.payload.statusIndex]?.dispositions ?? [];
      } else {
        state.dispositions = state.statuses?.flatMap((status) => status.dispositions) ?? [];
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTransactionsListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTransactionsListing.fulfilled, (state, action) => {
        state.ordersData = action?.payload?.orders;
        state.pagination = action?.payload?.pagination;
        state.loading = false;
        state.statuses = action?.payload?.statuses_and_dispositions ?? [];
      });
  },
});

export const { setOrders, filterDispositions, appendOrders } = TransactionsSlice.actions;
export default TransactionsSlice.reducer;
